import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const userRoutes: CustomRouteRecordRaw = {
  path: 'user',
  name: 'users',
  component: EmptyLayout,
  meta: {
    title: '用户管理',
    iconfont: 'icon-user-settings-line',
    requiredPermission: 'user'
  },
  children: [
    {
      path: 'personl-list',
      name: 'personalList',
      component: () => import('@/views/user/personal-list.vue'),
      meta: {
        title: '用户列表',
        requiredPermission: 'user.personal.list'
      },
    },
  ],
}
